<template>
	<div
		data-component="btn-container"
		:data-wrapper="hasWrapper"
	>
		<router-link data-element="btn"
			v-if="link"
			:to="href"
			:data-size="size"
			:data-inverse="inverse"
			:data-loading="loading"
			:class="{ inactive: inactive }"
			v-background-color="backgroundColor"
			>
			<span
				v-if="!loading"
				data-element="text"
				v-color="textColor"
				v-font-style="fontStyle"
				v-modify-leading="fontStyle"
				:style="{ fontSize: textSize }"
			>
				{{ text }}
			</span>
			<generic-loader v-else />
		</router-link>
		<button v-else
			data-element="btn"
			:data-size="size"
			:data-inverse="inverse"
			:data-loading="loading"
			:class="{ inactive: inactive }"
			:disabled="inactive || loading"
			v-background-color="backgroundColor"
			>
			<div data-element="text-container">
				<span
					v-if="!loading"
					data-element="text"
					v-color="textColor"
					v-font-style="fontStyle"
					v-modify-leading="fontStyle"
					:style="{ fontSize: textSize }"
				>
					{{ text }}
				</span>
				<generic-loader v-else />
			</div>
		</button>
	</div>
</template>

<script>
	import GenericLoader from '@/components/ui/GenericLoader';

	export default {
		props: [
			'text',
			'link',
			'href',
			'size',
			'inactive',
			'loading',
			'inverse',
			'backgroundColor',
			'textColor',
			'fontStyle',
			'hasWrapper'
		],
		components: {
			GenericLoader
		},
		computed: {
			uppercaseFont () {
				return this.fontStyle && this.fontStyle.uppercase;
			},
			textSize () {
				return this.fontStyle && this.fontStyle.textSize || '20px';
			}
		}
	}
</script>

<style lang="scss">

	@import '@/assets/scss/variables.scss';
	@import '@/assets/scss/helpers.scss';

	[data-component='btn-container'] {
		display:flex;
		align-items:center;
		justify-content:center;
		width:100%;
		-webkit-tap-highlight-color:transparent;
		&[data-wrapper] {
			padding:8px 0;
		}
		@include whenScreenIs(sm) {
			display:flex;
			justify-content:center;
		}
		[data-element='btn'] {
			width:100%;
			display:flex;
			align-items:center;
			justify-content:center;
			height:48px; width:100%;
			color:#ffffff;
			background:$jungle-green;
			border:none;
			-webkit-tap-highlight-color:transparent;
			@include whenScreenIs(sm) {
				max-width:336px;
			}
			&:hover {
				cursor:pointer;
			}
			&[data-size='md'] {
				width:calc(100% - 32px);
				margin:0 16px;
				@include whenScreenIs(sm) {
					width:336px;
				}
			}
			&[data-size='sm'] {
				height:50px; width:72px;
				@include whenScreenIs(sm) {
					height:48px;
				}
				@media (max-width: 370px) {
					width:65px;
				}
			}
			&[data-inverse] {
				background:#fff;
				border:1px solid $jungle-green;
				color:$jungle-green;
				&:hover{
					color:#fff;
				}
			}
			&[data-loading] {
				background-color:$jungle-green;
			}
			&.inactive {
				opacity:0.3;
				pointer-events:none;
				&:hover {
					cursor:default;
				}
			}
			// Need this for Safari 10 flexbox button bug:
			[data-element='text-container'] {
				display:flex;
				align-items:center;
				justify-content:center;
				width:100%;
				-webkit-tap-highlight-color:transparent;
			}
			[data-element='text']{
				text-align:center;
				line-height:1.33;
				font-size:20px;
				-webkit-tap-highlight-color:transparent;
			}
			&:focus {
				outline-color:#fff;
			}
			&:hover {
				background-color:$emerald;
				cursor:pointer;
			}
		}

	}


</style>
